<template>
  <div ref="content">
    <div class="wrapper">
      <BusinessHeader v-if="this.isloginHendle"></BusinessHeader>
      <HeaderNav menuflg="2" v-else></HeaderNav>
      <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
      _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
      <div class="body">
        <div class="inner">
          <div class="pankuzu">
            <ul>
              <li>
              <router-link 
                class="ico-home" 
                :to="{ name: this.isBop ? 'STFMFM02C29' : 'STFMFM01C01' }"
              >
              {{ this.isBop ? "ファイル一覧" : "メインページ"}}
              </router-link>
              </li>
              <li v-if="!this.isBop">
                <router-link 
                  :to="{ name: 'STFMFM02C01'}"
                >
                ファイル管理
              </router-link>
              </li>
              <li v-if="!this.isBop">
                <router-link
                :to="{ name: 'STFMFM02C29' }"
                >
                ファイル一覧
                </router-link>
              </li>
              <li>
                <span class="current">フォルダの編集</span>
              </li>
            </ul>
          </div>
          <div class="content-header">
            <h1 class="h1">フォルダの編集</h1>
            <p class="sub-title">{{ this.businessOperatorCode }}{{ this.businessOperatorName }}</p>
          </div>
          <!--****  メッセージ表示領域 ****-->
          <p class="errMsg title-ico ico-warning" v-show="errors != ''">
            <ErrorMessage :errors="errors"></ErrorMessage>
          </p>
          <p class="lead" style="white-space: pre-wrap;">
            {{
             this.headerComment
            }}
          </p>
          <div class="para" style="margin-left:0px;margin-top:40px">
            <div class="frm-row">
              <span class="frm-label w-90px"><strong>フォルダ名</strong></span>
              <input 
                type="text" 
                class="frm-text frm-size-487px"
                :class="{ error: this.errors_foldername!=''}"
                v-model="this.newFolderName"
                v-on:focusout="folderNameFocusout"
                ref="refNewFolderName"
                maxlength="247"
                :disabled="isDisabled"
              >
            </div>
          </div>
          <div class="folder-name-error">
            {{ this.errors_foldername }}
          </div>
          <!-- ******************************************************************
               *  アクセス権限情報                                              *
          ******************************************************************-->
          <div class="para" v-if="this.showFolderAccessAuthArea" style="margin-top:60px;margin-left:0px">
            <h2 class="h3">フォルダのアクセス権限情報</h2>
            <!-- legend -->
            <div class="legend">
              <ul>
                <li>
                  <img src="@/assets/images/TDSDC/icon_access-user.png" width="19" height="21" alt />
                  <strong>アクセス権限の設定が可能な利用者</strong>
                </li>
                <li v-if="!isMobile">
                  <span class="ico-tooltip" v-tooltip="{
                    title: this.msgAccessUser,
                    position: 'top',
                  }">
                    <img src="@/assets/images/TDSDC/icon_irai_help.png" width="18" height="20" alt />
                    {{ accessAuthDisplay }}
                  </span>
                </li>
                <li v-if="isMobile">
                  <span class="ico-tooltip" @click.stop="handleRemarksModal()">
                    <img src="@/assets/images/TDSDC/icon_irai_help.png" width="18" height="20" alt />
                    {{ accessAuthDisplay }}
                  </span>
                </li>
              </ul>
            </div>
            <!-- legend // -->
            <p class="lead">{{ this.commentAccessAuthHeader }}</p>
            <p class="sup-explanation">
              {{ this.commentAccessAuthLine1 }}
            </p>
            <p v-if="this.commentAccessAuthLine2!=''" class="sup-explanation" style="margin-top: 0px;">
              {{ this.commentAccessAuthLine2 }}
            </p>
            <br />
            <div v-if="this.showInheritAccessAuthArea" class="auth-area" >
              <div style="margin-top:10px">アクセス権限の引継ぎ</div>
              <div class="frm-toggle frm-size-toggle-2 ml-15px" ref="refInheritAccessAuth" tabindex="0" @keydown.left.stop.prevent="toggleRadio('inheritAccessAuth')" @keydown.right.stop.prevent="toggleRadio('inheritAccessAuth')"> 
                <label>
                  <input
                    type="radio"
                    id="collect1"
                    :value="true"
                    v-model="inheritAccessAuth"
                    :onChange="this.inheritAccessAuthChanged"
                    tabindex="-1"
                  />
                  <span>{{ this.inheritAccessAuthBtnText1 }}</span>
                </label>
                <label>
                  <input
                    type="radio"
                    id="collect2"
                    :value="false"
                    v-model="inheritAccessAuth"
                    tabindex="-1"
                  />
                  <span>{{ this.inheritAccessAuthBtnText2 }}</span>
                </label>
              </div>
            </div>
            <div v-if="this.showSetBopAccessAuthAreaForBop" class="checkbox-section" >
              <div style="margin-top:10px">事業者のアクセス権限</div>
              <div class="frm-toggle ml-15px"
              :style="this.isBop ? 'width:300px' : 'width:600px'" ref="refAllowAllBop" tabindex="0" @keydown.left.stop.prevent="toggleRadio('allowAllBop')" @keydown.right.stop.prevent="toggleRadio('allowAllBop')">
                <label>
                  <input
                    type="radio"
                    id="collect1"
                    :value="true"
                    v-model="allowAllBop"
                    tabindex="-1"
                  />
                  <span :class="this.isBop ? this.allowAllBopBtnWidth1 : this.allowAllBopBtnWidth2">{{ this.allowAllBopBtnText1 }}</span>
                </label>
                <label>
                  <input
                    type="radio"
                    id="collect2"
                    :value="false"
                    v-model="allowAllBop"
                    tabindex="-1"
                  />
                  <span :class="this.isBop ? this.allowAllBopBtnWidth1 : this.allowAllBopBtnWidth2">{{ this.allowAllBopBtnText2 }}</span>
                </label>
              </div>
            </div>
            <div v-if="this.showSetUserAccessAuthArea">
              <h3 class="h4">利用者のアクセス権限の設定</h3>
              <div class="swap-row">
                <div class="swap-left">
                  <h3 class="h4">アクセスを許可する利用者</h3>
                  <div class="frm-row">
                    <div class="frm-search frm-size-xl" :class="[
                      searchKeyPermission ? showSearched : showUnsearched,
                    ]">
                      <span class="frm-label">
                        &nbsp;
                        <img src="@/assets/images/TDSDC/icon_search.png" />
                      </span>
                      <input type="search" class="frm-search-text" placeholder="検索キーワード" maxlength="255" :disabled="
                        sortPermissionList.length === 0 && !searchKeyPermission
                      " v-model.trim="searchKeyPermission" />
                    </div>
                  </div>
                  <div class="frm-item alignright">
                    <p>{{ permissionCount }}</p>
                  </div>
                  <!-- table -->
                  <div class="table-wrap" style="margin-top: 0px">
                    <div class="table-scroll-header">
                      <table class="table-select multi-select">
                        <colgroup>
                          <col style="width: 40px" />
                          <col style="width: 170px" />
                          <col style="width: auto" />
                          <col style="width: 110px" />
                        </colgroup>
                        <thead >
                          <tr>
                            <!-- 全選択解除 -->
                            <th class="multi-select-item aligncenter">
                              <label class="frm-checkbox">
                                <input type="checkbox" 
                                  :checked="isAllSelectedPermission" 
                                  @click="selectAllRowPermission " 
                                  tabindex="0"
                                  :disabled="
                                    sortPermissionList.every((e) => !e.enabled) ||
                                    sortPermissionList.length === 0
                                  " />
                                <span class="checkbox-item" :tabindex="
                                                                  sortPermissionList.every((e) => !e.enabled) ||
                                sortPermissionList.length === 0
                                ? -1
                                : 0" 
                                  @keydown.space.stop.prevent="
                                    selectAllRowPermission
                                  "></span>
                              </label>
                            </th>
                            <th class="sort hover alignleft" @click="sortPermissionData('id')" >
                              ログインID/
                              <br />グループコード
                              <div class="sort-toggle">
                                <button class="sort-toggle-asc" tabindex="-1" :class="
                                  sortPermission.key == 'id' &&
                                    sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  asc
                                </button>
                                <button class="sort-toggle-desc" tabindex="-1" :class="
                                  sortPermission.key == 'id' &&
                                    !sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  desc
                                </button>
                              </div>
                            </th>
                            <th class="sort hover alignleft" @click="sortPermissionData('name')">
                              利用者/名称
                              <div class="sort-toggle">
                                <button class="sort-toggle-asc" tabindex="-1" :class="
                                  sortPermission.key == 'name' &&
                                    sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  asc
                                </button>
                                <button class="sort-toggle-desc" tabindex="-1" :class="
                                  sortPermission.key == 'name' &&
                                    !sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  desc
                                </button>
                              </div>
                            </th>
                            <th class="sort hover" @click="sortPermissionData('authority')">
                              権限
                              <div class="sort-toggle">
                                <button class="sort-toggle-asc" tabindex="-1" :class="
                                  sortPermission.key == 'authority' &&
                                    sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  asc
                                </button>
                                <button class="sort-toggle-desc" tabindex="-1" :class="
                                  sortPermission.key == 'authority' &&
                                    !sortPermission.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  desc
                                </button>
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="table-scroll-body h-395px">
                      <table class="table-select multi-select">
                        <colgroup>
                          <col style="width: 40px" />
                          <col style="width: 170px" />
                          <col style="width: auto" />
                          <col style="width: 110px" />
                        </colgroup>
                        <tbody>
                          <tr v-for="info in sortPermissionList" :key="info.id" @click="selectRow(info)" :class="{
                            selected: info.selected,
                            disabled: !info.enabled,
                          }">
                            <!-- 選択 -->
                            <td class="multi-select-item aligncenter">
                              <label class="frm-checkbox" @keydown.space.stop.prevent="selectRow(info)" >
                                <!-- 収集方法が対象外の場合は非活性-->
                                <input type="checkbox" :checked="info.selected" @click="selectRow(info)"
                                  :disabled="info.enabled == false" />
                                <span class="checkbox-item" :tabindex="info.enabled == false ? -1 : 0"></span>
                              </label>
                            </td>
                            <td class="group" :class="{
                              'ico-folder': info.icon,
                              'ico-user': !info.icon,
                            }">
                              <span>{{ info.id }}</span>
                            </td>
                            <td>
                              <span>{{ info.name }}</span>
                            </td>
                            <td class="aligncenter">
                              <span>
                                {{ accessAuthFormat(info.authority) }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="table-select single-select" style="background: #fff"
                        v-show="sortPermissionList.length === 0">
                        <tbody>
                          <tr>
                            <p class="noData-area">
                              {{ noDataMsg }}
                            </p>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- table // -->
                </div>
                <div class="swap-center">
                  <div class="swap-btn-col">
                    <button class="swap-btn permission" type="button" @click="handlePermission"
                      :disabled="!sortDeniedList.some((e) => e.selected)" >
                      追加
                    </button>
                    <button class="swap-btn rejection" type="button" @click="handleDenied"
                      :disabled="!sortPermissionList.some((e) => e.selected)">
                      削除
                    </button>
                  </div>
                </div>
                <div class="swap-right">
                  <h3 class="h4">利用者一覧</h3>
                  <div class="frm-row">
                    <div class="frm-search frm-size-xl" :class="[searchKeyDenied ? showSearched : showUnsearched]">
                      <span class="frm-label">
                        &nbsp;
                        <img src="@/assets/images/TDSDC/icon_search.png" />
                      </span>
                      <input type="search" class="frm-search-text" placeholder="検索キーワード" maxlength="255" v-model.trim="searchKeyDenied"
                        :disabled="
                          sortDeniedList.length === 0 && !searchKeyDenied
                        " />
                    </div>
                  </div>
                  <!-- table -->
                  <div class="frm-item alignright">
                    <p>{{ deniedCount }}</p>
                  </div>
                  <div class="table-wrap" style="margin-top: 0px">
                    <div class="table-scroll-header">
                      <table class="table-select scroll">
                        <colgroup>
                          <col style="width: 40px" />
                          <col style="width: 170px" />
                          <col style="width: auto" />
                          <col style="width: 110px" />
                        </colgroup>
                        <thead>
                          <tr>
                            <!-- 全選択解除 -->
                            <th class="multi-select-item aligncenter">
                              <label class="frm-checkbox">
                                <input type="checkbox" tabindex="0" :checked="isAllSelectedDenied" @click="selectAllRowDenied"
                                  :disabled="sortDeniedList.length === 0" />
                                <span class="checkbox-item" :tabindex="sortDeniedList.length === 0 ? -1 : 0"
                                  @keydown.space.stop.prevent="selectAllRowDenied"></span>
                              </label>
                            </th>
                            <th class="sort hover alignleft" @click="sortDeniedData('id')">
                              ログインID/
                              <br />グループコード
                              <div class="sort-toggle">
                                <button class="sort-toggle-asc" tabindex="-1" :class="
                                  sortDenied.key == 'id' && sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  asc
                                </button>
                                <button class="sort-toggle-desc" tabindex="-1" :class="
                                  sortDenied.key == 'id' && !sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  desc
                                </button>
                              </div>
                            </th>
                            <th class="sort hover alignleft" @click="sortDeniedData('name')">
                              利用者/名称
                              <div class="sort-toggle">
                                <button class="sort-toggle-asc" tabindex="-1" :class="
                                  sortDenied.key == 'name' && sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  asc
                                </button>
                                <button class="sort-toggle-desc" tabindex="-1" :class="
                                  sortDenied.key == 'name' && !sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  desc
                                </button>
                              </div>
                            </th>
                            <th class="sort hover" @click="sortDeniedData('authority')">
                              権限
                              <div class="sort-toggle">
                                <button class="sort-toggle-asc" tabindex="-1" :class="
                                  sortDenied.key == 'authority' &&
                                    sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  asc
                                </button>
                                <button class="sort-toggle-desc" tabindex="-1" :class="
                                  sortDenied.key == 'authority' &&
                                    !sortDenied.isAsc
                                    ? 'on'
                                    : ''
                                " type="button">
                                  desc
                                </button>
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="table-scroll-body h-395px">
                      <table class="table-select scroll">
                        <colgroup>
                          <col style="width: 40px" />
                          <col style="width: 170px" />
                          <col style="width: auto" />
                          <col style="width: 110px" />
                        </colgroup>
                        <tbody>
                          <tr v-for="info in sortDeniedList" :key="info.id" @click="selectRow(info)" :class="{
                            selected: info.selected,
                            disabled: !info.enabled,
                          }">
                            <!-- 選択 -->
                            <td class="multi-select-item aligncenter">
                              <label class="frm-checkbox" @keydown.space.stop.prevent="selectRow(info)">
                                <!-- 収集方法が対象外の場合は非活性-->
                                <input type="checkbox" :checked="info.selected" @click="selectRow(info)"
                                  :disabled="!info.enabled" />
                                <span class="checkbox-item" :tabindex="!info.enabled ? -1 : 0"></span>
                              </label>
                            </td>
                            <td class="group" :class="{
                              'ico-folder': info.icon,
                              'ico-user': !info.icon,
                            }">
                              <span>{{ info.id }}</span>
                            </td>
                            <td>
                              <span>{{ info.name }}</span>
                            </td>
                            <td class="aligncenter">
                              <span>
                                {{ accessAuthFormat(info.authority) }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="table-select single-select" style="background: #fff"
                        v-show="sortDeniedList.length === 0">
                        <tbody>
                          <tr>
                            <p class="noData-area">
                              {{ noDataMsg }}
                            </p>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- table // -->
                </div>
              </div>
            </div>
            <!-- swap // -->
            <div v-if="this.showSetBopAccessAuthArea" class="checkbox-section">
              <h3 class="h4">事業者のアクセス権限の設定</h3>
              <div style="display: flex;height: 40px;margin-bottom: 30px;">
                <div style="margin-top:10px;margin-left: 13px;">当フォルダへのアクセス</div>
                <div class="frm-toggle frm-size-toggle-2 ml-15px" ref="refnheritAllowBopAccessFolder" tabindex="0" @keydown.left.stop.prevent="toggleRadio('allowBopAccessFolder')" @keydown.right.stop.prevent="toggleRadio('allowBopAccessFolder')">
                  <label>
                    <input
                      type="radio"
                      id="collect1"
                      :value="true"
                      v-model="allowBopAccessFolder"
                      tabindex="-1"
                    />
                    <span>許可</span>
                  </label>
                  
                  <label>
                    <input
                      type="radio"
                      id="collect2"
                      :value="false"
                      v-model="allowBopAccessFolder"
                      tabindex="-1"
                    />
                    <span>拒否</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- table // -->
          <!-- ******************************************************************
               *  下部ボタン群                                                  *
          ******************************************************************-->
          <div class="frm-btn-row footer-btn">
            <div class="frm-item grow center">
              <button class="frm-btn strong large" type="button" :disabled="isDisabled" @click="handleUpdateFolder"
                >
                確定
              </button>
              <button class="frm-btn large" type="button" @click="handleCancelUpdateBtnClicked" ref="refCancelUpdateBtn">
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      ダイアログ定義：前画面へ戻る際の確認ダイアログ                                                                _/
        _/                                                                                                                    _/
  _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
  <!-- キャンセルボタン押下による確認画面 -->
  <STFMFM02C08ConfirmDialog 
    :isShow="this.cancelConfirmDialogSetting.isShow"
    :message="this.cancelConfirmDialogSetting.message" 
    :confirmText="this.cancelConfirmDialogSetting.confirmText" 
    :cancelText="this.cancelConfirmDialogSetting.cancelText" 
    :cancelText3="this.cancelConfirmDialogSetting.cancelText3" 
    :title="this.cancelConfirmDialogSetting.title" 
    @confirm="cancelConfirmDialogConfirm"
    @cancel="cancelConfirmDialogCancel"
    >
  </STFMFM02C08ConfirmDialog>
  <BaseModal :show="remarksModal.show">
    <div class="popup">
      <div class="popup-head bg-colore-gray">
        <img src="@/assets/images/TDSDC/icon_irai_help.png" width="18" height="20" alt />
      </div>
      <div class="popup-body">
        <div class="popup-status">
         {{remarksModal.text}}
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button
              tabindex="0"
              class="frm-btn strong large"
              @click="remarksModal={show:false,text:''}"
              ref="closeButton"
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapMutations } from "vuex";
import HeaderNav from "@/components/AccountingHeader.vue";
import BusinessHeader from "@/components/BusinessHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Validation from "@/util/validation.js";
import { ACCESS_AUTH } from "@/util/enum.js";
import Common from "@/util/common.js";
import STFMFM02C08ConfirmDialog from "@/components/STFMFM02C08ConfirmDialog.vue";
import { API_STFMFM02C06_Initialize, API_STFMFM02C06_UpdateFolder, API_STFMFM02C06_UnLockFolder } from '@/api/Modules/FM02/STFMFM02C06.js'
import BaseModal from "@/components/Base/BaseModal.vue";

export default {
  name: "STFMFM02C06",
  components: {
    HeaderNav,
    BusinessHeader,
    ErrorMessage,
    STFMFM02C08ConfirmDialog,
    BaseModal
  },
  data() {
    return {
      newFolderName: "",
      commentAccessAuthHeader: "",
      commentAccessAuthLine1: "",
      commentAccessAuthLine2: "",
      inheritAccessAuthBtnText1: "",
      inheritAccessAuthBtnText2: "",
      inheritAccessAuth: true,
      // 事業者のアクセス(許可または拒否)
      allowBopAccessFolder: true,
      // 事業者用の事業者のアクセス(全員または自分のみ)
      allowAllBopBtnText1: "",
      allowAllBopBtnText2: "",
      allowAllBopBtnWidth1: "btn-width-150",
      allowAllBopBtnWidth2: "btn-width-271",
      allowAllBop: true,
      isloginHendle: this.$cookies.get("isloginHendle") == "true" ? true : false,
      isBop: false,
      businessOperatorCode: "",
      businessOperatorName: "",
      currentFolderKey: {},
      // ルートフォルダか
      isRootFolder: false,
      // オーナか
      isOwner: false,
      // オーナタイプ(0:ユーザー,1:ワークグループ,2:事業者ユーザー)
      ownerType: 0,
      // 管理者ログインか
      isAdminLogin: false,
      // フォルダーのアクセス権限設定表示エリア制御
      showFolderAccessAuthArea: false,
      //  [アクセス権限の引継ぎ(グループ)]エリア制御
      showInheritAccessAuthArea: false,
      //  [利用者のアクセス権限の設定]エリア制御
      showSetUserAccessAuthArea: false,
      // [事業者のアクセス権限の設定]エリア制御
      showSetBopAccessAuthArea: false,
      // [事業者のアクセス権限の設定(事業者用)]エリア制御
      showSetBopAccessAuthAreaForBop: false,
      userAccessAuthorityMode: 0,
      bopUserAccessAuthorityMode: 0,
      headerComment: "",
      selectCountPermission: 0,
      showSelectCountPermission: false,
      selectCountDenied: 0,
      showCountDenied: true,
      showSelectCountDenied: false,
      noDataMsg: Common.getMessage("MTCL1118", ["利用者"]),
      showSearched: "frm-search frm-size-xl setvalue",
      showUnsearched: "frm-search frm-size-xl",
      rdoCorporationDivision: 1, // 法人個人区分選択値
      searchKeyPermission: "", // アクセス許可フィルタテキスト
      highlightsPermission: [],
      highlightPermissionIndex: -1,
      searchKeyDenied: "", // アクセス拒否フィルタテキスト
      highlightsDenied: [],
      highlightDeniedIndex: -1,
      authorityInfoList: [], // アクセス許可リスト
      deniedData: [], // アクセス拒否リスト
      
      errors: [], // エラー情報
      errors_foldername: "",
      sortPermission: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      sortDenied: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      msgAccessBop: "アクセス権限の設定が可能な利用者は、税理士事務所(管理者)とフォルダの作成者です。", // アクセス権限のツールチップ表示メッセージ
      msgAccessUser: "アクセス権限の設定が可能な利用者は、管理者（システム管理者）とフォルダの作成者です。", // アクセス権限のツールチップ表示メッセージ
      isSelectDivision: null, // 許可リスト、拒否リストのどちらを選択しているか null:未選択 true:許可リスト false:拒否リスト
      content: "", // メッセージ
      toRouter: "", // 遷移先画面
      accessAuthDisplay: [], // アクセス権限の設定が可能なユーザー
      workgroupList: [], // ワークグループリスト
      userList: [], // ユーザーリスト
      isDisabled: false,
      permissionDataCope: [], // アクセス許可リスト_コッピ
      deniedDataCope: [], // アクセス拒否リスト_コッピ
      isSearchKeyEnter: false,
      /** キャンセルボタン押下による確認画面 */
      cancelConfirmDialogSetting: {},
      remarksModal:{
        show:false,
        text:""
      },
      isMobile:Common.isMobile(),
    };
  },
  created() {
    // 画面遷移チェック用メッセージ初期化
    this.content = Common.getMessage("MTCL2001", []);
  },
  mounted() {
    this.isDisabled = true;
    this.processDialogue(true);
    
    // フォルダ新規登録画面の初期処理
    API_STFMFM02C06_Initialize().then((response) => {
      //正常の場合
      if (_.eq(response.result, "0000")) {
        
        this.isBop = response.isBop;
        this.newFolderName = response.folderName;
        this.bopUserAccessAuthorityMode = response.bopUserAccessAuthorityMode;
        this.userAccessAuthorityMode = response.userAccessAuthorityMode;
        this.isOwner = response.isOwner;
        this.ownerType = response.ownerType;
        this.isAdminLogin = response.isAdminLogin;
        this.accessAuthDisplay = response.accessAuthDisplay;
        this.businessOperatorCode = response.businessOperatorCode;
        this.businessOperatorName = "_" + response.businessOperatorName;
        this.currentFolderKey = response.currentFolderKey;
        this.isRootFolder = response.isRootFolder;
        
        this.msgAccessUser = "";
        if(this.ownerType != 2){
          this.msgAccessUser = "アクセス権限の設定が可能な利用者は、管理者（システム管理者）とフォルダの作成者です。";
        }
        else{
          if(this.isAdminLogin){
            this.msgAccessUser = "アクセス権限の設定が可能な利用者は、管理者（システム管理者）とフォルダの作成者です。";
          }
          else{
            this.msgAccessUser = "アクセス権限の設定が可能な利用者は、税理士事務所(管理者)とフォルダの作成者です。";
          }
        }
        this.SetCommentAccessAuth();
        this.SetInheritAccessAuthBtnText();
        this.SetAllowAllBopBtnText();
        // owner=user
        if(this.ownerType == 0){
          // loginuser=admin or isowner
          if(this.isAdminLogin || this.isOwner){
            // フォルダアクセス権限設定エリア
            this.showFolderAccessAuthArea = true;
            this.showInheritAccessAuthArea = true;
            if(this.userAccessAuthorityMode == 4){
              this.inheritAccessAuth = true;
              this.showSetUserAccessAuthArea = false;
              this.showSetBopAccessAuthArea = false;
            }
            else if(this.userAccessAuthorityMode == 2){
              this.inheritAccessAuth = false;
              this.showSetUserAccessAuthArea = true;
              this.showSetBopAccessAuthArea = true;
              if (this.bopUserAccessAuthorityMode != 3) {
                this.allowBopAccessFolder = true;
              }
              else {
                this.allowBopAccessFolder = false;
              }
            }
            this.showSetBopAccessAuthAreaForBop = false;
          }
          // loginuer=user && not isowner
          else if (!this.isBop && !this.isOwner){
            this.showFolderAccessAuthArea = false;
          }
          // loginuser=bop
          else if(this.isBop){
            this.showFolderAccessAuthArea = false;
          }
        }
        // owner=bop
        else if(this.ownerType == 2){
          this.showSetUserAccessAuthArea = false;
          this.showSetBopAccessAuthArea = false;
          // loginuser=admin or isowner
          if (this.isAdminLogin || this.isOwner){
            // parentfolder=root
            if(this.isRootFolder){
              this.showFolderAccessAuthArea = true;
              this.showInheritAccessAuthArea = false;
              this.showSetBopAccessAuthAreaForBop = true;
              // deny
              if(this.bopUserAccessAuthorityMode == 3){
                this.allowAllBop = false;
              }
              else{
                this.allowAllBop = true;
              }
            }
            // not rootfolder
            else{
              this.showFolderAccessAuthArea = true;
              this.showInheritAccessAuthArea = true;
              // inherit
              if(this.bopUserAccessAuthorityMode == 4){
                this.inheritAccessAuth = true;
                this.showSetBopAccessAuthAreaForBop = false;
              }
              else{
                this.inheritAccessAuth = false;
                this.showSetBopAccessAuthAreaForBop = true;
              }
              
              if (this.bopUserAccessAuthorityMode == 3){
                this.allowAllBop = false;
              }
              else{
                this.allowAllBop = true;
              }
            }
          }
          // not adminlogin && not isowner
          else if (this.isBop && !this.isOwner) {
            this.showFolderAccessAuthArea = false;
          }
        }
          
        // [コメント]の表示内容
        if(this.isAdminLogin || this.isOwner){
          this.headerComment = "フォルダを編集します。\nフォルダ名、アクセス権限に関する設定を行ってください。";
        }
        else{
          this.headerComment ="フォルダを編集します。";
        }
        
        // 税理士事務所ログイン且つオーナが事業者ではない場合
        if(this.ownerType != 2 && (this.isAdminLogin || this.isOwner)){
            
          // 権限付与ユーザリストを設定
          this.authorityInfoList = response.authorityInfoList.map((e) => {
            return { ...e, permission: true, selected: false };
          });
          
          this.authorityInfoList = response.authorityInfoList.filter(
            (val) => val.permission === true && val.id != ""
          );
          this.authorityInfoList = response.authorityInfoList
            .filter((val) => val.id != "")
            .map((e) => {
              return { ...e, selected: false };
            });
          this.workgroupList = response.workgroupList;
          this.userList = response.userList;
          this.isSearchKeyEnter = true;

          // アクセス権限許可ユーザリストの選択リスト初期化
          this.authorityInfoList.forEach((value, index, array) => {
            // ソート用にシーケンスを付与
            if (array[index].icon) {
              array[index].sortSequence = 0;
            } else {
              array[index].sortSequence = 1;
            }
          });
          this.deniedData.forEach((value, index, array) => {
            // ソート用にシーケンスを付与
            if (array[index].icon) {
              array[index].sortSequence = 0;
            } else {
              array[index].sortSequence = 1;
            }
          });
          this.deniedDataCope = [...this.deniedData];
          this.permissionDataCope = [...this.authorityInfoList];
        }
        
        this.isDisabled = false;
        // 初期フォーカス設定(フォルダ名)
        this.$nextTick(() => this.$refs.refNewFolderName.focus());
      }
      else{
        this.isDisabled = true;
        this.$nextTick(() => this.$refs.refCancelUpdateBtn.focus());
        this.errors.push(
          Common.createError(response.errorCD, Common.getMessage(response.errorCD, []))
        );
      }
      this.processDialogue(false);
    });

   
  },

  beforeRouteLeave(to, from, next) {
    // 画面遷移チェック
    if (
      !this.$cookies.get("SessionID") ||
      to.name == "STDSCM04C06" ||
      this.toRouter
    ) {
      next();
    } else {
      this.toRouter = to;
      this.cancelConfirmDialogSetting = {
        isShow: true,
        message: Common.getMessage("MTCL2001", []),
        confirmText: "はい",
        cancelText: "いいえ",
      };
    }
  },
  watch: {
    // 引継ぎ変更
    inheritAccessAuth: function (newVal) {
      this.SetshowSetUserAccessAuthArea();
      this.SetShowSetBopAccessAuthArea();
      this.SetShowSetBopAccessAuthAreaForBop();

    },
  },
  computed: {
    permissionCount() {
      const totalNumber = this.authorityInfoList.filter((e) => e.permission).length;
      const total = totalNumber.toLocaleString();
      if (this.searchKeyPermission){
        const permissionCount = this.sortPermissionList.length.toLocaleString();
        return `${permissionCount}/${total}件`
      }
      else{
        return `${total}件`;
      }
    },
    deniedCount() {
      const totalNumber = this.authorityInfoList.filter((e) => !e.permission).length;
      const total = totalNumber.toLocaleString();
      if (this.searchKeyDenied){
        const deniedCount = this.sortDeniedList.length.toLocaleString();
        return `${deniedCount}/${total}件`
      }
      else{
        return `${total}件`;
      }
    },
    isAllSelectedDenied() {
      return (
        this.sortDeniedList.every((e) => !e.enabled) ||
        this.sortDeniedList
          .filter((e) => e.enabled)
          .every((info) => info.selected)
      );
    },
    isAllSelectedPermission() {
      return (
        this.sortPermissionList.every((e) => !e.enabled) ||
        this.sortPermissionList
          .filter((e) => e.enabled)
          .every((info) => info.selected)
      );
    },
    // 許可リストのソート
    sortPermissionList() {
      let list = this.authorityInfoList.filter((e) => e.permission);

      //検索キーワード

      list = list.filter((item) => {
        return (
          item.id.includes(this.searchKeyPermission) ||
          item.name.includes(this.searchKeyPermission) ||
          this.accessAuthFormat(item.authority).includes(
            this.searchKeyPermission
          )
        );
      });

      list = Common.listSort(
        this.sortPermission.key,
        this.sortPermission.isAsc,
        list
      );

      return list;
    },
    // 拒否リストのソート
    sortDeniedList() {
      let list = this.authorityInfoList.filter((e) => !e.permission);

      //検索キーワード

      list = list.filter((item) => {
        return (
          item.id.includes(this.searchKeyDenied) ||
          item.name.includes(this.searchKeyDenied) ||
          this.accessAuthFormat(item.authority).includes(this.searchKeyDenied)
        );
      });

      list = Common.listSort(this.sortDenied.key, this.sortDenied.isAsc, list);

      return list;
    },
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),

    /**
     * フォルダ名フォーカスアウト処理
     */
    folderNameFocusout(){
      this.newFolderName = this.newFolderName.trimEnd();
    },
    /**
     * 画面キャンセル
     */
    handleCancelUpdateBtnClicked() {
      this.toRouter = { name: "STFMFM02C29" };

      this.cancelConfirmDialogSetting = {
        isShow: true,
        message: Common.getMessage("MTCL2001", []),
        confirmText: "はい",
        cancelText: "いいえ",
      };
    },
    /**
         * キャンセル確認画面でキャンセルボタン押下
         */
    cancelConfirmDialogCancel() {
      this.cancelConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
      this.toRouter = "";
    },
    /**
     * キャンセル確認画面でOKボタン押下
     */
    cancelConfirmDialogConfirm() {
      this.cancelConfirmDialogSetting = {
        isShow: false,
        message: "",
        confirmText: "",
        cancelText: "",
      };
      this.processDialogue(true);
      API_STFMFM02C06_UnLockFolder().then(async (response) => {
        //正常の場合
        if (_.eq(response.result, "0000")) {
          // システムエラーのみのためエラーハンドル不要
        }
        this.processDialogue(false);
        this.isProcessing = false;
        this.$redirect(this.toRouter);
      });
    },

    // 引継ぎボタン名設定
    SetInheritAccessAuthBtnText(){
      // 税理士事務所の場合
      if (!this.isBop) {
       
        this.inheritAccessAuthBtnText1 = "上位のフォルダのアクセス権限を引継ぐ";
        this.inheritAccessAuthBtnText2 = "アクセス権限を引き継がず、個別に設定する";

      }
      else {
        this.inheritAccessAuthBtnText1 = "上位のフォルダのアクセス権限を引継ぐ";
        this.inheritAccessAuthBtnText2 = "アクセス権限を引き継がず、個別に設定する";
      }
    },
    // 事業者のアクセス権限(事業者用)ボタン名設定
    SetAllowAllBopBtnText() {
      // 事業者の場合
      if (this.isBop) {

        this.allowAllBopBtnText1 = "全員";
        this.allowAllBopBtnText2 = "自分のみ";

      }
      else {
        this.allowAllBopBtnText1 = "事業者全員";
        this.allowAllBopBtnText2 = "アクセス権限の設定が可能な事業者のみ";
      }
    },
    // コメントアクセス設定
    SetCommentAccessAuth(){
      // 税理士事務所の場合
      if(this.ownerType != 2){
        this.commentAccessAuthHeader = "フォルダのアクセス権限を設定します。";
        this.commentAccessAuthLine1 = "アクセスが許可されている利用者のみ、当フォルダ（配下のフォルダ、ファイルを含む）にアクセスできます。";
        this.commentAccessAuthLine2 = "";
      }
      else{
        this.commentAccessAuthHeader = "事業者に対するフォルダのアクセス権限を設定します。";
        this.commentAccessAuthLine1 = "アクセスが許可されている事業者のみ、当フォルダ（配下のフォルダ、ファイルを含む）にアクセスできます。";
        this.commentAccessAuthLine2 = "税理士事務所は事業者のアクセス権限に関わらずすべてのフォルダにアクセスできます。";
      }
    },
    // [アクセス権限の引継ぎ(グループ)]エリア制御
    SetShowInheritAccessAuthArea(){
      // 税理士事務所の場合表示
      if (!this.isBop){
        // オーナが事業者の場合
        if(this.ownerType == 2){
          if(this.isRootFolder){
            // 引継ぎボタン非表示
            this.showInheritAccessAuthArea = false;
          }
          else{
            // 引継ぎボタン表示
            this.showInheritAccessAuthArea = true;
          }
        }
        else{
          // 引継ぎボタン表示
          this.showInheritAccessAuthArea = true;
        }
        
      }
      // 事業者の場合
      else{
        // ルートフォルダの場合非表示
        if (this.isRootFolder){
          this.showInheritAccessAuthArea = false;
        }
        else{
          this.showInheritAccessAuthArea = true;
        }
      }
    },
    //  [利用者のアクセス権限の設定]エリア制御
    SetshowSetUserAccessAuthArea() {
      if(this.isBop || (!this.isAdminLogin && !this.isOwner) || this.ownerType == 2){
        this.showSetUserAccessAuthArea = false;
      }
      else{
        // アクセス権限の引継ぎを選択した場合
        if(this.inheritAccessAuth){
          this.showSetUserAccessAuthArea = false;
        }
        else{
          this.showSetUserAccessAuthArea = true;
        }
      }
    },
    // [事業者のアクセス権限の設定]エリア制御
    SetShowSetBopAccessAuthArea() {
      // 税理士事務所ログインの場合
      if (!this.isBop) {
        // オーナが事業者以外の場合
        if(this.ownerType != 2){
          // アクセス権限の引継ぎを選択した場合
          if (this.inheritAccessAuth) {
            this.showSetBopAccessAuthArea = false;
          }
          else {
            this.showSetBopAccessAuthArea = true;
          }
        }
        // オーナが事業者の場合
        else{
          this.showSetBopAccessAuthArea = false;
          
        }
      }
      // 事業者ログインの場合
      else {
        this.showSetBopAccessAuthArea = false;
      }
    },
    // [事業者のアクセス権限の設定(事業者用)]エリア制御
    SetShowSetBopAccessAuthAreaForBop() {
      if (this.ownerType != 2){
        this.showSetBopAccessAuthAreaForBop = false;
      }
      else{
        if(this.inheritAccessAuth){
          this.showSetBopAccessAuthAreaForBop = false;
        }
        else{
          this.showSetBopAccessAuthAreaForBop = true;
        }
      }
    },

    // 全行選択時の処理
    selectAllRowDenied() {
      if (this.isAllSelectedDenied) {
        this.sortDeniedList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = false;
            // }
          });
      } else {
        this.sortDeniedList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = true;
            // }
          });
      }
    },

    // 全行選択時の処理
    selectAllRowPermission() {
      if (this.isAllSelectedPermission) {
        this.sortPermissionList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = false;
            // }
          });
      } else {
        this.sortPermissionList
          .filter((e) => e.enabled)
          .forEach((info) => {
            // if (info.status != 99) {
            info.selected = true;
            // }
          });
      }
    },
    sortPermissionData(key) {
      // isAsc 昇順ならtrue,降順ならfalse
      this.sortPermission.isAsc =
        this.sortPermission.key === key ? !this.sortPermission.isAsc : true;
      this.sortPermission.key = key;
    },

    sortDeniedData(key) {
      // isAsc 昇順ならtrue,降順ならfalse
      this.sortDenied.isAsc =
        this.sortDenied.key === key ? !this.sortDenied.isAsc : true;
      this.sortDenied.key = key;
    },
    // 行選択
    selectRow(info) {
      // 管理権限ユーザー以外の場合
      if (info.enabled) {
        info.selected = !info.selected;
      }
    },
    // **********************************************
    // * 検索アイコンをクリック時、該当する部分の色を変える_アクセス許可リスト
    // **********************************************
    searchNextPermission() {
      if (this.highlightsPermission.length > 0) {
        let targetIndex = this.highlightPermissionIndex;
        const maxIndex = this.highlightsPermission.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightPermissionIndex = targetIndex;

        for (let i = 0; i < this.highlightsPermission.length; i++) {
          const target = this.highlightsPermission[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
          }
        }
      }
    },
    // **********************************************
    // * 検索アイコンをクリック時、該当する部分の色を変える_アクセス拒否リスト
    // **********************************************
    searchNextDenied() {
      if (this.highlightsDenied.length > 0) {
        let targetIndex = this.highlightDeniedIndex;
        const maxIndex = this.highlightsDenied.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightDeniedIndex = targetIndex;

        for (let i = 0; i < this.highlightsDenied.length; i++) {
          const target = this.highlightsDenied[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
          }
        }
      }
    },
    // アクセス権限フォーマット
    accessAuthFormat(data) {
      // グループ
      if (data == ACCESS_AUTH.group.code) {
        return ACCESS_AUTH.group.text;
      }
      // 管理者
      else if (data == ACCESS_AUTH.admin.code) {
        return ACCESS_AUTH.admin.text;
      }
      // 管理ユーザー
      else if (data == ACCESS_AUTH.adminUser.code) {
        return ACCESS_AUTH.adminUser.text;
      }
      // 一般ユーザー
      else if (data == ACCESS_AUTH.generalUser.code) {
        return ACCESS_AUTH.generalUser.text;
      }
    },
    // 許可ボタン押下時
    handlePermission() {
      //検索キーワード
      this.sortDeniedList
        .filter((e) => e.selected)
        .forEach((e) => {
          e.permission = true;
          e.selected = false;
        });
    },
    // 拒否ボタン押下時
    handleDenied() {
      //検索キーワード
      this.sortPermissionList
        .filter((e) => e.selected)
        .forEach((e) => {
          e.permission = false;
          e.selected = false;
        });
    },
    checkFolderName(){
      // 必須チェック
      if (!Validation.isRequired(this.newFolderName)){
        this.errors.push(
          Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
        );
        this.errors_foldername = Common.getMessage("MTCL1001", ["フォルダ名"]);
        return false;
      }
      
      // 入力禁止文字チェック
      if (
        !Validation.checkNationalkinsokuchar(this.newFolderName) ||
        !Validation.CheckFileNameInvalid(this.newFolderName)
      ) {
        this.errors.push(
          Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
        );
        this.errors_foldername = Common.getMessage("MTCL1098", ["フォルダ名"]);
        return false;
      }
      // COM0...チェック
      if (!Validation.CheckFileName(this.newFolderName)){
        this.errors.push(
          Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
        );
        this.errors_foldername = Common.getMessage("MTFM1190", ["フォルダ名"]);
        return false;
      }
      return true;
    },
    // 登録ボタン押下
    handleUpdateFolder() {
      // エラースタイルの初期化
      this.errorStyleInit();
      // エラー情報の初期化
      this.errors = [];
      
      if(!this.checkFolderName()){
        this.$nextTick(function () {
          this.moveToTop();
          this.$refs.refNewFolderName.focus();
        });
        return;
      }

      this.processDialogue(true);
      
      let paramWorkgroupList = [];
      let paramUserList = [];
      let paramBopUserList = [];
      if(this.showFolderAccessAuthArea){
        this.updateFolderNameOnly = false;
        if(!this.inheritAccessAuth){
          this.workgroupList.forEach((value, index, array) => {
            if (
              this.authorityInfoList.filter(
                (val) =>
                  val.authority === 0 &&
                  val.keyName === value.keyName &&
                  val.id === value.workgroupCode &&
                  val.permission
              ).length > 0
            ) {
              paramWorkgroupList.push(value);
            }
          });
          this.userList.forEach((value, index, array) => {
            if (
              this.authorityInfoList.filter(
                (val) =>
                  (val.authority === 2 || val.authority === 3) &&
                  val.keyName === value.keyName &&
                  val.id === value.id &&
                  val.permission
              ).length > 0
            ) {
              paramUserList.push(value);
            }
          });
        }
      }
      else {
        this.updateFolderNameOnly = true;
      }

      this.getUserAuthMode();

      // 登録パラメータ
      const param = {
        //フォルダーキー情報
        CurrentFolderKey: this.currentFolderKey,
        //フォルダー名のみ更新
        UpdateFolderNameOnly: this.updateFolderNameOnly,
        // フォルダー名
        FolderName: this.newFolderName,
        // ユーザーアクセス権限設定方法
        UserAccessAuthorityMode: this.userAccessAuthorityMode,
        // アクセス許可するワークグループリスト
        WorkgroupList: paramWorkgroupList,
        // アクセス許可するユーザーリスト
        UserList: paramUserList,
        // 事業者ユーザーアクセス権限設定方法
        BopUserAccessAuthorityMode: this.bopUserAccessAuthorityMode,
        // アクセスを許可する事業者ユーザーリスト
        bopUserList: paramBopUserList,
      };

      this.isDisabled = true;
      API_STFMFM02C06_UpdateFolder(param).then((response) => {
        // 正常終了の場合、一覧画面に戻る
        if (response.result == "0000") {
          this.toRouter = "STFMFM02C29";
          this.$router.push({
            name: "STFMFM02C29",
          });
        } else {
          if (response.errorNameList != null && response.errorNameList.length > 0){
            this.errors.push(
              Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
            );
            this.errors_foldername = Common.getMessage(response.errorCD, response.errorNameList);
          }
          else{
            var paraList = [];
            if (response.errorParaList != null) {
              paraList = response.errorParaList;
            }
            this.errors.push(
              Common.createError(response.errorCD, Common.getMessage(response.errorCD, paraList))
            )
          }
          this.$nextTick(function () {
            this.moveToTop();
            this.$refs.refNewFolderName.focus();
          });
        }
        this.isDisabled = false;
        this.processDialogue(false);
      });
    },
    // 税理士事務所又は事業者の権限モード取得
    getUserAuthMode(){
      if(!this.showFolderAccessAuthArea){
        this.userAccessAuthorityMode = 0;
        this.bopUserAccessAuthorityMode = 0;
        return;
      }

      // オーナが事務所の場合
      if(this.ownerType != 2){
        // 権限引継ぎの場合
        if (this.inheritAccessAuth) {
          this.userAccessAuthorityMode = 4;
          this.bopUserAccessAuthorityMode = 4;
        }
        // 個別設定の場合
        else {
          // 事業者許可の場合
          if (this.allowBopAccessFolder) {
            this.userAccessAuthorityMode = 2;
            this.bopUserAccessAuthorityMode = 1;
          }
          else {
            this.userAccessAuthorityMode = 2;
            this.bopUserAccessAuthorityMode = 3;
          }
        }
      }
      // オーナが事業者の場合
      else{
        // 達人ユーザ全部許可
        this.userAccessAuthorityMode = 1;
        // ルートフォルダの場合
        if(this.isRootFolder){
          // 全員許可の場合
          if(this.allowAllBop){
            this.bopUserAccessAuthorityMode = 1;
          }
          else{
            this.bopUserAccessAuthorityMode = 3;
          }
        }
        // ルートフォルダ以外の場合
        else{
          // 権限の引継ぎの場合
          if(this.inheritAccessAuth){
            this.bopUserAccessAuthorityMode = 4;
          }
          // 個別設定の場合
          else{
            // // 全員許可の場合
            if (this.allowAllBop) {
              this.bopUserAccessAuthorityMode = 1;
            }
            else {
              this.bopUserAccessAuthorityMode = 3;
            }
          }
        }
      }
    },
    
    // エラースタイルを初期化する
    errorStyleInit() {
      this.errors.splice(0);
      this.errors_foldername = "";
    },
     /**
     * 画面の最上位に移動
     */
    moveToTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    },
    /**
     * ラジオボタンの矢印キー制御
     */
    toggleRadio(e) {
      if(e == "inheritAccessAuth"){
        this.inheritAccessAuth = !this.inheritAccessAuth;
      }
      else if(e == "allowAllBop"){
        this.allowAllBop = !this.allowAllBop;
      }
      else if(e == "allowBopAccessFolder"){
        this.allowBopAccessFolder = !this.allowBopAccessFolder;
      }
    },
    handleRemarksModal(){
      this.remarksModal = {show:true,text:this.isloginHendle ? this.msgAccessBop : this.msgAccessUser} 
    }
  },
};
</script>
<style scoped>
.folder-name-error {
  margin-left: 98px;
  height: 12px;
  color: red;
}
.btn-width-150{
  width: 150px;
}
.btn-width-271 {
  width: 271px;
}
.frm-size-toggle-width-600px{
  width: 600px;
}
.frm-size-toggle-width-176px{
  width: 176px;
}
.folder-name-error {
  margin-left: 98px;
  height: 12px;
  color: red;
}
.checkbox-section{
  display: flex;height: 40px;margin-bottom: 30px;
}
.auth-area{
  display: flex;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 30px;
}
.auth-area .frm-toggle{
  width: 600px;
}
@media (max-width: 768px) {
  .checkbox-section{
    flex-direction: column;
    align-items: flex-start;
  }
  .checkbox-section .frm-toggle {
    margin-left: 0;
    margin-top: 15px;
  }
  .folder-name-error{
    margin-left: 0;
  }
  .frm-btn-row  .frm-btn {
    min-width: 33%;
  }
  .auth-area{
    height: unset;
    flex-wrap: wrap;
  }
  .auth-area >div:nth-of-type(1){
    margin-bottom: 10px;
  }
  .auth-area>.frm-toggle{
    /* margin-left: 0; */
    width: unset;
    display: flex;
    flex-wrap: wrap;
  }
  .auth-area>.frm-toggle>label{
    margin-bottom: 10px;
  }
  .auth-area>.frm-toggle>label>span{
    border-radius:6px;
  }
  .frm-toggle>label+label{
    border-left: none;
  }

}
</style>